import LootTable from "../game/LootTable";

export const lootTables = {
  "bronzeSet": new LootTable({
    id: 'bronzeSet',
    items: ['bronzeHelmet','bronzeGauntlets','bronzeGreeves','bronzeDagger','bronzeAxe','bronzeShield','bronzeGreatsword','bronzeChestplate'],
  }),
  "bronzeWeapon": new LootTable({
    id: 'bronzeWeapon',
    items: ['bronzeDagger','bronzeAxe','bronzeShield','bronzeGreatsword'],
  }),
  "bronzeArmor": new LootTable({
    id: 'bronzeArmor',
    items: ['bronzeHelmet','bronzeGauntlets','bronzeGreeves','bronzeChestplate'],
  }),
  "ironSet": new LootTable({
    id: 'ironSet',
    items: ['ironHelmet','ironGauntlets','ironGreeves','ironDagger','ironAxe','ironShield','ironGreatsword','ironChestplate'],
  }),
  "ironWeapon": new LootTable({
    id: 'ironWeapon',
    items: ['ironDagger','ironAxe','ironShield','ironGreatsword'],
  }),
  "ironArmor": new LootTable({
    id: 'ironArmor',
    items: ['ironHelmet','ironGauntlets','ironGreeves','ironChestplate'],
  }),
};